import { useAuthStore } from '../stores/authStore'

/** True when zustand persist has finished reading localStorage. */
export function isAuthHydrated(): boolean {
  return useAuthStore.getState()._hasHydrated || useAuthStore.persist.hasHydrated()
}

/** Align `_hasHydrated` with persist when the flag was never set (blocks inbox sync). */
export function syncAuthHydratedFlag(): void {
  if (isAuthHydrated() && !useAuthStore.getState()._hasHydrated) {
    useAuthStore.getState().setHasHydrated(true)
  }
}
